// extracted by mini-css-extract-plugin
export default {"documentBundle":"tWKcQf1d2VrjFVU8AN5O"};